const dev = process.env.NODE_ENV !== 'production';
export const baseApi = dev
  ? process.env.REACT_APP_URL
  : process.env.REACT_APP_URL;

export const skippableRequestInterceptor = ['/login'];
